import { useEffect } from "react";

// Shared subpage shell: a calm, static luxury-photograph backdrop behind the
// site's glass/charcoal sections — content-focused, no live 3D on subpages.
export default function PageShell({ children, backdrop = "/homes/hero-interior.webp", title }) {
  useEffect(() => {
    if (title) document.title = title;
  }, [title]);
  return (
    <div className="relative">
      <div className="fixed inset-0 z-0" aria-hidden="true">
        <img src={backdrop} alt="" className="w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-charcoal/75" />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal via-transparent to-charcoal" />
      </div>
      <div className="relative z-10 pt-16">{children}</div>
    </div>
  );
}
